import { Injectable, Optional, Inject } from '@angular/core';
import { NativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE)  matDateLocale: string, // Inject the locale
    private translate: TranslateService
  ) {
    super(matDateLocale); // Pass the locale to the parent constructor
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const weekdaysKey = 'Weekdays';
    const weekdays = this.translate.instant(weekdaysKey) as string[];
    console.log('Translated weekdays:', weekdays);
    return this.mapStyle(weekdays, style);
  }

  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const monthsKey = 'Months';
    const months = this.translate.instant(monthsKey) as string[];
    console.log('Translated weekdays:', months);
    return this.mapStyle(months, style);
  }

  override format(date: Date): string {
    if (!date) return '';

    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear();

    // If locale is Thai, use Buddhist Era (B.E.)
    const displayYear = localStorage.getItem("lan")== 'th' ? year + 543 : year;

    // Format: MM/DD/YYYY
    return `${day}/${month}/${displayYear}`;
  }

  // Override the parse method to handle input correctly
  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.trim()) {
      const parts = value.split('/');
      if (parts.length === 3) {
        // Months are zero-based
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        let year = parseInt(parts[2], 10);

        // If locale is Thai, convert Buddhist Era (B.E.) to Gregorian year
        if (localStorage.getItem("lan")== 'th') {
          year -= 543;
        }

        return new Date(year, month, day);
      }
    }
    return null; // Invalid value
  }

  override getYearName(date: Date): string {
    const year = date.getFullYear();
    const displayYear =localStorage.getItem("lan")== 'th' ? year + 543 : year;
    return `${displayYear}`;
  }
 
  private mapStyle(names: string[], style: 'long' | 'short' | 'narrow'): string[] {
    if (style === 'short') return names.map((name) => name.slice(0, 3)); // First 3 characters for short
    if (style === 'narrow') return names.map((name) => name[0]); // First character for narrow
    return names; // Full names for long
  }
}
